export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  SIGN_OUT: '/sign-out',
  SUPPORT: '/support',
  BEHAVIORAL_HEALTH: '/get-care/behavioral-health',
  PERSONAL_INFORMATION: '/settings/personal-information',
  COMMUNICATION_PREFERENCES: '/settings/communication-preferences',
  CAREGIVER: '/caregiver',
  CAREGIVER_CLAIM: '/caregiver/claim',
};
